/**
 * 퍼널 식별자 관리 (SSOT)
 * - 이 파일이 landingFunnelKey의 단일 진실 공급원(Single Source of Truth)입니다.
 * - 새 퍼널 추가 시 반드시 여기에 먼저 추가하세요.
 * - 상세 정책(paths, product 등)은 direct 프로젝트 내부에서 정의합니다.
 */
export const landingFunnelKey = {
  GROUP: {
    100: `GROUP_100`,
    toss_100: `GROUP_toss_100`,
    adv: `GROUP_adv`,
    private_thanks: "GROUP_private_thanks",
    promotion_25_i: `GROUP_promotion_25_i`,
    promotion_25_i_t: `GROUP_promotion_25_i_t`,
    promotion_25_j: `GROUP_promotion_25_j`,
    promotion_25_3d3: `GROUP_promotion_25_3d3`,
    promotion_25_3d3_2: `GROUP_promotion_25_3d3_2`,
    promotion_25_k: `GROUP_promotion_25_k`,
    promotion_25_l: `GROUP_promotion_25_l`,
    promotion_25_m: `GROUP_promotion_25_m`,
    promotion_9900: `GROUP_promotion_9900`,
    hbf_9900: `GROUP_hbf_9900`,
    hbf_mixed: `GROUP_hbf_mixed`,
    hbf_mixed_v2: `GROUP_hbf_mixed_v2`,
    hbf_mixed_mt: `GROUP_hbf_mixed_mt`,
    promotion_26_c: `GROUP_promotion_26_c`,
    promotion_26_d: `GROUP_promotion_26_d`,
    promotion_26_up_a: `GROUP_promotion_26_up_a`,
    promotion_26_up_b: `GROUP_promotion_26_up_b`,
    promotion_26_up_c: `GROUP_promotion_26_up_c`,
    promotion_26_hp: `GROUP_promotion_26_hp`,
    promotion_26_e: `GROUP_promotion_26_e`,
    promotion_26_f: `GROUP_promotion_26_f`,
    referral_promotion_05: "GROUP_referral_promotion_05",
    // promotion_26_g: `GROUP_promotion_26_g`,
    // promotion_26_h: `GROUP_promotion_26_h`,
    kakao_bank_mt: `GROUP_kakao_bank_mt`, // 카카오뱅크 메모리얼
    kakao_bank: `GROUP_kakao_bank`, // 카카오뱅크
    memorial_table: `GROUP_memorial_table`,
    memorial_table_my_v2: `GROUP_memorial_table_my_v2`, // /my/v2 stage-c 진입용 (S1MT 일시납만 노출)
    memorial_table_goodfuneral: `GROUP_memorial_table_goodfuneral`, // /message/good-funeral 진입용 (S1MT 일시납만 노출)
    gas_app: `GROUP_gas_app`,
    promotion_279_mt: `GROUP_promotion_279_mt`, // 279 메모리얼 빌더 전용
    promotion_279_mt_single: `GROUP_promotion_279_mt_single`, // 279 메모리얼 3만원 일시납
    promotion_279_mt_all: `GROUP_promotion_279_mt_all`, // 279 메모리얼 전체 추모 (100원/3만원/9900원 모두 추모)
    promotion_279_mt_mixed: `GROUP_promotion_279_mt_mixed`, // 289 DC10 혼합 (100원/3만원 일반 + 9900원 추모+3개월) 실효가 279만원
    promotion_259_mt: `GROUP_promotion_259_mt`, // 259 메모리얼 빌더 전용
    promotion_289_mt_mixed: `GROUP_promotion_289_mt_mixed`, // 289 메모리얼 혼합 (100원/3만원/9900원)
    promotion_289_mt_all: `GROUP_promotion_289_mt_all`, // 289 메모리얼 전체 추모 (100원/3만원/9900원 모두 추모)
    tdt_9900: `GROUP_tdt_9900`, // 삼쩜삼 9900 단독
    promotion_saving_10: `GROUP_promotion_saving_10`, // 100원/3만원 노혜택 + 9900원 3개월면제+10만할인
    ggr_mixed: `GROUP_ggr_mixed`, // GGR 채널 (100원 / 9,900원)
    mdy_mixed: `GROUP_mdy_mixed`, // 모두의연결 채널 (100원 / 9,900원)
    lpt_mixed: `GROUP_lpt_mixed`, // 엘포인트 채널 (100원 / 9,900원)
    okc_mixed: `GROUP_okc_mixed`, // 오케이캐쉬백 채널 (100원 / 9,900원)
    promotion_289_mt_coupon: `GROUP_promotion_289_mt_coupon`, // 289 메모리얼 쿠폰 프로모션
    promotion_289_mt_coupon_tdt: `GROUP_promotion_289_mt_coupon_tdt`, // 289 메모리얼 쿠폰 삼쩜삼
    promotion_25_3d3_mt_zero: `GROUP_promotion_25_3d3_mt_zero`, // 삼쩜삼 추모테이블 첫달무료
    tdt_mt_mixed: `GROUP_tdt_mt_mixed`, // 삼쩜삼 추모테이블 (100원 추모 / 9900원 3개월면제+추모)
    revisit_30: `GROUP_revisit_30`, // 30분 재방문 20만원 할인 전용
    rfr_mixed: `GROUP_rfr_mixed`, // 레퍼리오 채널 (100원 / 9,900원)
    kpay_mt_mixed: `GROUP_kpay_mt_mixed`, // 카카오페이 추모테이블 (100원 / 3만원 / 9900원)
    kbank_mt_mixed: `GROUP_kbank_mt_mixed`, // 카카오뱅크 추모테이블 (100원 / 3만원 / 9900원)
    promotion_279_hsv: `GROUP_promotion_279_hsv`, // 홈쇼핑 전용 279만원
  },
} as const;
